import {
  AudienceFiltersDto,
  ExperiencePageTargetingFe,
  ExpressionNodeQueryType,
} from "@intelligems/ig-types";

export const pageTargetingSplice = (
  pageTargeting: ExperiencePageTargetingFe[]
) => {
  const updatedTargets: ExperiencePageTargetingFe[] = [];

  pageTargeting.forEach((target) => {
    let localTarget: ExperiencePageTargetingFe = target;
    let originUrl: URL | undefined = undefined;
    try {
      originUrl = new URL(localTarget.value);

      localTarget = {
        ...localTarget,
        value: originUrl.pathname.startsWith("/")
          ? originUrl.pathname.substring(1)
          : originUrl.pathname,
      };
    } catch (e) {
      localTarget = { ...localTarget };
    }
    updatedTargets.push(localTarget);
  });
  return updatedTargets;
};

export const getChosenCondition = (
  resource: ExperiencePageTargetingFe | AudienceFiltersDto | undefined
) => {
  return resource !== undefined && resource.filterType
    ? resource.filterType
    : null;
};

export const containsQueryParam = (value: string) => {
  return value.includes("?");
};

export const getTargetKeyValue = (
  resource: ExperiencePageTargetingFe | AudienceFiltersDto,
  resourceType: "queryParams" | "pageTargeting",
  key: keyof ExpressionNodeQueryType
) => {
  if (resourceType === "queryParams") {
    return (resource as AudienceFiltersDto)!.expression![0]!.query![key];
  } else {
    return (resource as ExperiencePageTargetingFe)[key];
  }
};
